import React, { useState } from 'react';
import { setShowRequestedBenefitModal } from '../../redux/modules/show';
import { Alert, Button, Col, Form, Image, Modal, ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import PsePayment from '../PsePayment/PsePayment';
import CardPayment from '../CardPayment/CardPayment';
import DescuentoNomina from '../DescuentoNomina/DescuentoNomina';
import { getTotalAmount, getTotalAmountInfo } from '../../utils/amounts';
import { formatMoney } from '../../utils/formatMoney';
import './styles/requestedBenefitModal.scss';

const select = state => {
  return {
    user: state.auth.user,
    token: state.auth.token,
    userId: state.auth.userId,
    showRequestedBenefitModal: state.show.showRequestedBenefitModal
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setShowRequestedBenefitModal: show => dispatch(setShowRequestedBenefitModal(show))
  };
}

const benefitAmountValues = [
  { value: '20000', label: '20.000', amount: 20000 },
  { value: '50000', label: '50.000', amount: 50000 },
  { value: '100000', label: '100.000', amount: 100000 },
  { value: '200000', label: '200.000', amount: 200000 }
];

function ConnectedRequestedBenefitModal(props) {

  const { benefit, userId, token } = props;
  const [stage, setStage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paymentStage, setPaymentStage] = useState(false);
  const [otherAmount, setOtherAmount] = useState('');
  const [paymentType, setPaymentType] = useState('PSE');
  const [selectedBenefitAmount, setSelectedBenefitAmount] = useState('20000');

  const handleClose = () => {
    props.setShowRequestedBenefitModal({ show: false });

    setStage(0);
    setLoading(false);

    props.onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);

    const prom = await fetch(`${apiUrl}/requestedBenefits/resolve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        requestId: benefit._id
      })
    });

    const resp = await prom.json();

    if (resp.success) setStage(2);
    else alert(resp.message || 'Error. Inténtalo nuevamente.');

    setLoading(false);
  };

  const handlePaymentStep = () => {
    if (selectedBenefitAmount === 'OTRO') {
      if (!otherAmount) return alert('Ingresa un valor.');
      // if (benefitApplication.benefitAmount > 0 && parseInt(otherAmount) > benefitApplication.benefitAmount - Math.floor(benefitApplication.amountRaised || 0)) return alert(`El valor máximo es ${benefitApplication.benefitAmount - Math.floor(benefitApplication.amountRaised || 0)}`)
    }

    setPaymentStage(true);
  };

  const amountInfo = getTotalAmountInfo(parseInt(selectedBenefitAmount !== 'OTRO' ? selectedBenefitAmount : otherAmount), paymentType);

  return (
    <div>
      <Modal show={props.showRequestedBenefitModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
        </Modal.Header>
        {
          benefit &&
          <div className="requested-benefit-modal">
            {
              loading ?
              <Modal.Body>
                <AppSpinner />
              </Modal.Body> :
              stage === 0 ?
              <>
                <Modal.Body>
                  <h3>{benefit.name}</h3>
                  {
                    benefit.thumbnail &&
                    <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                      <Image
                        src={benefit.thumbnail}
                        rounded
                        style={{ maxHeight: '300px' }}
                      />
                    </div>
                  }
                  <p>
                    <strong>Ubicación: </strong>{benefit.location}
                  </p>
                  <p>
                    <strong>Descripción: </strong> {benefit.description}
                  </p>
                  {
                    benefit.moneyRaise &&
                    <div className="benefit-progress-bar">
                      <div className="progress-label">
                        {
                          benefit.amountRaised && parseInt(benefit.amountRaised) >= benefit.goal ?
                          '¡Meta alcanzada!' :
                          `${!benefit.amountRaised ? 0 : formatMoney(Math.floor(benefit.amountRaised))} de ${formatMoney(benefit.goal)}`
                        }
                      </div>
                      <ProgressBar now={!benefit.amountRaised ? 0 : (benefit.amountRaised / benefit.goal) * 100} />
                    </div>
                  }
                </Modal.Body>
                <Modal.Footer>
                  <div style={{ display: 'block', margin: '0 auto' }}>
                    <Button className="app-button" onClick={() => setStage(1)} disabled={benefit.moneyRaise && benefit.amountRaised && parseInt(benefit.amountRaised) >= benefit.goal}>
                      Quiero contribuir con esta necesidad
                    </Button>
                  </div>
                </Modal.Footer>
              </> :
              stage === 1 ?
              <>
                {
                  benefit.moneyRaise ?
                  <>
                    <Modal.Body className="coupon-modal-content">
                      {
                        paymentStage ?
                        <Col xs={12}>
                          <i className="fas fa-arrow-alt-circle-left back-icon" onClick={() => setPaymentStage(false)} />
                          {
                            paymentType === 'PSE' ?
                            <PsePayment
                              amount={selectedBenefitAmount !== 'OTRO' ? getTotalAmount(parseInt(selectedBenefitAmount), 'PSE') : getTotalAmount(parseInt(otherAmount), 'PSE')}
                              paymentType={'CUSTOM_BENEFIT_PAYMENT'}
                              requestedBenefitId={benefit._id}
                            /> :
                            paymentType === 'CARD' ?
                            <CardPayment
                              amount={selectedBenefitAmount !== 'OTRO' ? getTotalAmount(parseInt(selectedBenefitAmount), 'CARD') : getTotalAmount(parseInt(otherAmount), 'CARD')}
                              paymentType={'CUSTOM_BENEFIT_PAYMENT'}
                              requestedBenefitId={benefit._id}
                            /> :
                            <DescuentoNomina
                              amount={selectedBenefitAmount !== 'OTRO' ? getTotalAmount(parseInt(selectedBenefitAmount), 'DESCUENTO_NOMINA') : getTotalAmount(parseInt(otherAmount), 'DESCUENTO_NOMINA')}
                              paymentType={'CUSTOM_BENEFIT_PAYMENT'}
                              requestedBenefitId={benefit._id}
                            />
                          }
                        </Col> :
                        <Form.Row>
                          <Col xs={12}>
                            <Alert variant="info">
                              A continuación te mostramos los valores asociados a este pago.
                              Ten en cuenta que el <strong>monto final</strong> a pagar depende del método de pago que selecciones:
                              <ul>
                                <li>
                                  <strong>
                                    {
                                      paymentType === 'PSE' ? 'PSE:' :
                                      paymentType === 'CARD' ? 'Tarjeta de crédito:' :
                                      'Descuento de nómina:'
                                    }
                                  </strong>
                                  <ul>
                                    <li>Valor del bono: {formatMoney(selectedBenefitAmount !== 'OTRO' ? selectedBenefitAmount : otherAmount)}</li>
                                    <li>Costos financieros y de tecnología: {formatMoney(amountInfo.totalDiscounted)}</li>
                                    <li>TOTAL: {formatMoney(amountInfo.total)}</li>
                                  </ul>
                                </li>
                              </ul>
                            </Alert>
                          </Col>
                          <Form.Group as={Col} md={6}>
                            <Form.Label className="app-label">Valor del bono</Form.Label>
                            <Form.Control
                              as="select"
                              value={selectedBenefitAmount}
                              onChange={event => setSelectedBenefitAmount(event.target.value)}
                            >
                              {
                                benefitAmountValues.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
                              }
                              <option value="OTRO">Otro</option>
                            </Form.Control>
                          </Form.Group>
                          {
                            selectedBenefitAmount === 'OTRO' &&
                            <Form.Group as={Col} md={6}>
                              <Form.Label className="app-label">Valor</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Valor"
                                value={otherAmount}
                                onChange={event => setOtherAmount(event.target.value)}
                                required
                              />
                            </Form.Group>
                          }
                          <Form.Group as={Col} md={6}>
                            <Form.Label className="app-label">Método de pago</Form.Label>
                            <Form.Control
                              as="select"
                              value={paymentType}
                              onChange={event => setPaymentType(event.target.value)}
                            >
                              <option value="PSE">PSE</option>
                              <option value="CARD">Tarjeta de crédito</option>
                              <option value="DESCUENTO_NOMINA">Descuento de nómina</option>
                            </Form.Control>
                          </Form.Group>
                          <Col xs={12}>
                            <Button className="app-button" onClick={handlePaymentStep}>
                              Continuar
                            </Button>
                          </Col>
                        </Form.Row>
                      }
                    </Modal.Body>
                  </> :
                  <>
                    <Modal.Body>
                      <Alert variant="info">
                        ¿Deseas confirmar que quieres contribuir con esta necesidad?
                        Si confirmas te pondremos en contacto con la persona que solicitó esta ayuda para que puedan concretar los detalles con respecto a la solicitud.
                      </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                      <div style={{ display: 'block', margin: '0 auto' }}>
                        <Button
                          variant="secondary"
                          onClick={handleClose}
                          style={{ margin: '0 10px', width: '150px' }}
                        >
                          Cancelar
                        </Button>
                        <Button
                          className="app-button"
                          style={{ margin: '0 10px', width: '150px' }}
                          onClick={handleSubmit}
                        >
                          Confirmar
                        </Button>
                      </div>
                    </Modal.Footer>
                  </>
                }
              </> :
              stage === 2 ?
              <Modal.Body>
                <h3 className="title">
                  Tu solicitud para constribuir con esta ayuda fue procesada con éxito. Pronto nos comunicaremos contigo a través de tu correo electrónico para indicarte los pasos a seguir.
                </h3>
                <Button className="app-button" onClick={handleClose} style={{ display: 'block', margin: '15px auto', width: '150px' }}>
                  Aceptar
                </Button>
              </Modal.Body> :
              null
            }
          </div>
        }
      </Modal>
    </div>
  );
}

const RequestedBenefitModal = connect(select, mapDispatchToProps)(ConnectedRequestedBenefitModal);

export default RequestedBenefitModal;
